import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { createStructuredSelector } from 'reselect'
import styled from 'styled-components'
import {
  Button,
  Row,
} from 'reactstrap'
import get from 'lodash/get'
import set from 'lodash/set'
import { timesheetAction } from '../../../../actions'
import { timesheetSelector } from '../../../../selectors'
import { FONTS } from '../../../../constants'

const CategoryButton = class extends React.Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    const tempState = prevState
    const options = get(nextProps, 'getOptionsTimesheetStatus.filterButtonStatus')
    if (options && options !== prevState.filterButtonStatus) {
      set(tempState, 'filterButtonStatus', get(nextProps, 'getOptionsTimesheetStatus.filterButtonStatus'))
    }
    return tempState
  }

  state={ filterButtonStatus: 1 }

  clickFilterButton = (filter) => {
    const options = get(this.props, 'getOptionsTimesheetStatus')
    this.props.setOptionsTimesheetStatus({ ...options, filterButtonStatus: filter })
  }

  render() {
    const props = this.props
    const { filterButtonStatus } = this.state
    const meta = get(props, 'timesheetStatus.meta')
    const numberOfTimesheet = get(meta, 'numberOfTimesheet', 0)
    const timesheetApproved = get(meta, 'timesheetApproved', 0)
    const timesheetPending = get(meta, 'timesheetPending', 0)
    const timesheetRejected = get(meta, 'timesheetRejected', 0)
    const timesheetUnsubmited = get(meta, 'timesheetUnsubmited', 0)

    return (
      <Wrapper>
        <Categorybutton
          onClick={ () => this.clickFilterButton(1) }
          active={ filterButtonStatus === 1 }
        >
          <TextRow>
            <Circle />
            <TextButton color=''>Show All</TextButton>
          </TextRow>
          <TextRow>
            <TextNumber >{ `${numberOfTimesheet} People` }</TextNumber>
          </TextRow>
        </Categorybutton>
        <Categorybutton
          onClick={ () => this.clickFilterButton(2) }
          active={ filterButtonStatus === 2 }
        >
          <TextRow>
            <Circle
              color='#BBBBBB'
              active={ filterButtonStatus === 2 }
            />
            <TextButton
              color='#BBBBBB'
              active={ filterButtonStatus === 2 }
            >
            Unsubmitted
            </TextButton>
          </TextRow>
          <TextRow>
            <TextNumber>{ `${timesheetUnsubmited} People` }</TextNumber>
          </TextRow>
        </Categorybutton>
        <Categorybutton
          onClick={ () => this.clickFilterButton(3) }
          active={ filterButtonStatus === 3 }
        >
          <TextRow>
            <Circle
              color='#F0AD4E'
              active={ filterButtonStatus === 3 }
            />
            <TextButton
              color='#F0AD4E'
              active={ filterButtonStatus === 3 }
            >Pending</TextButton>
          </TextRow>
          <TextRow>
            <TextNumber>{ `${timesheetPending} People`}</TextNumber>
          </TextRow>
        </Categorybutton>
        <Categorybutton
          onClick={ () => this.clickFilterButton(4) }
          active={ filterButtonStatus === 4 }
        >
          <TextRow>
            <Circle
              color='#5CB85C'
              active={ filterButtonStatus === 4 }
            />
            <TextButton
              color='#5CB85C'
              active={ filterButtonStatus === 4 }
            >
            Approve
            </TextButton>
          </TextRow>
          <TextRow>
            <TextNumber>{ `${timesheetApproved} People`}</TextNumber>
          </TextRow>
        </Categorybutton>
        <Categorybutton
          onClick={ () => this.clickFilterButton(5) }
          active={ filterButtonStatus === 5 }
        >
          <TextRow>
            <Circle
              color='#D44B49'
              active={ filterButtonStatus === 5 }
            />
            <TextButton
              color='#D44B49'
              active={ filterButtonStatus === 5 }
            >
            Rejected
            </TextButton>
          </TextRow>
          <TextRow>
            <TextNumber>{ `${timesheetRejected} People`}</TextNumber>
          </TextRow>
        </Categorybutton>
      </Wrapper>
    )
  }
}

CategoryButton.propTypes = {
  setOptionsTimesheetStatus: PropTypes.func.isRequired,
}

const mapStateToProps = (state, props) => createStructuredSelector({
  getOptionsTimesheetStatus: timesheetSelector.getOptionsTimesheetStatus,
})(state, props)
const mapDispatchToProps = dispatch => bindActionCreators({
  setOptionsTimesheetStatus: timesheetAction.setOptionsTimesheetStatus,
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(CategoryButton)

const Categorybutton = styled(Button)`
  background-color: ${(props) => {
    if (props.active) {
      return '#D44B49 !important'
    } return '#ffffff'
  }};
  color: #000;
  height: 50px;
  width: 10%;
  margin: 5px;
  border: ${(props) => {
    if (props.active) {
      return '1px solid #D44B49 !important'
    } return '#cccccc'
  }};
  cursor: pointer;
`
const TextRow = styled(Row)`
  justify-content: center;
`
const TextButton = styled.label`
  font-family: ${FONTS.GOTHAM} !important;
  text-align: center;
  margin-bottom: 0;
  color: ${(props) => {
    if (props.active) {
      return '#ffffff !important'
    } return props.color
  }};
  font-size: ${FONTS.SMALL_SIZE};
  cursor: pointer;
`
const TextNumber = styled.label`
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  text-align: center;
  margin-bottom: 0;
  width: 100%;
  font-size: ${FONTS.SMALL_SIZE};
  cursor: pointer;
`
const Wrapper = styled.div`
  background-color: #EEEEEE ;
  height: 60px;
  display: flex;
  flex-direction: row;
  flex: 1;
  align-items: center;
  border-top: 1px solid #CCCCCC;
  border-bottom: 1px solid #EEEEEE;
  padding-left: 10px;
`
const Circle = styled.div`
  height: 8px;
  width: 8px;
  background-color: ${(props) => {
    if (props.active) {
      return '#ffffff !important'
    } return props.color
  }};
  border-radius: 50%;
  margin-right: 5px;
  margin-bottom: auto ;
  margin-top: auto;
`



// WEBPACK FOOTER //
// ./src/components/timesheet/tab-content/timesheet-status/category-button.js